import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Receipt, Shield, BookOpen, Activity } from 'lucide-react';
import { Avatar, AvatarFallback } from './Avatar';
export function Sidebar() {
  const navItems = [{
    name: 'Dashboard',
    path: '/',
    icon: LayoutDashboard
  }, {
    name: 'Discharge Summaries',
    path: '/discharge-summaries',
    icon: FileText
  }, {
    name: 'Billing Items',
    path: '/billing-items',
    icon: Receipt
  }, {
    name: 'Insurance Cases',
    path: '/insurance-cases',
    icon: Shield
  }];
  return <div className="fixed left-0 top-0 h-full w-[240px] bg-card border-r border-border flex flex-col" data-id="element-17">
      {/* Logo */}
      <div className="p-6 flex items-center gap-2" data-id="element-18">
        <img src="https://cdn.magicpatterns.com/uploads/3yRTvjooLGyNLLPhPvyzeu/Asika_Clear_Logo.png" alt="Asika Logo" className="h-10 w-auto" data-id="element-19" />
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-2 space-y-1 overflow-y-auto" data-id="element-20">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-secondary hover:text-foreground'}`} data-id="element-21">
            <item.icon className="w-5 h-5" data-id="element-22" />
            {item.name}
          </NavLink>)}

        {/* Knowledge Base */}
        <NavLink to="/knowledge-base" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-secondary hover:text-foreground'}`} data-id="element-23">
          <BookOpen className="w-5 h-5" data-id="element-24" />
          Knowledge Base
        </NavLink>
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-border" data-id="element-25">
        <div className="flex items-center gap-3 px-2" data-id="element-26">
          <Avatar className="h-10 w-10 border border-border" data-id="element-27">
            <AvatarFallback className="bg-primary text-primary-foreground" data-id="element-28">
              CC
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col" data-id="element-29">
            <span className="text-sm font-bold text-foreground" data-id="element-30">
              Clinical Coder
            </span>
            <span className="text-xs text-muted-foreground" data-id="element-31">
              Asika Hospital
            </span>
          </div>
        </div>
      </div>
    </div>;
}